const templates =  {
    "shop.okraina.ru": {
        title: "Работа в Окраине",
        tags: [

        ]
    },
    "dostavka.okraina.ru": {
        title: "Работа в Окраине",
        tags: [

        ]
    },
}

export default templates;